import { Button } from '@mui/material';
import { useNavigate } from 'react-router';
import DefaultSizeIconify from '../icons/DefaultSizeIconify';

export const GoBackButtonWithIcon: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Button variant="contained" onClick={() => navigate(-1)}>
      <DefaultSizeIconify
        icon="ic:outline-arrow-back"
        sx={{
          mr: 1,
        }}
      />
      Nazad
    </Button>
  );
};
